import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = (data, totalRevenue, totalOrders, filename = 'statistiche_tap2order') => {
  try {
    // Create workbook
    const wb = XLSX.utils.book_new();

    // Prepare summary data
    const summaryData = [
      { 'Metrica': 'Fatturato Totale', 'Valore': `€${totalRevenue.toFixed(2)}` },
      { 'Metrica': 'Numero Totale Comande', 'Valore': totalOrders },
      { 'Metrica': 'Piatti Diversi Ordinati', 'Valore': data.length },
      { 'Metrica': 'Media per Comanda', 'Valore': totalOrders > 0 ? `€${(totalRevenue / totalOrders).toFixed(2)}` : '€0.00' }
    ];

    // Create summary worksheet
    const summaryWs = XLSX.utils.json_to_sheet(summaryData);
    summaryWs['!cols'] = [
      { wch: 25 }, // Metrica
      { wch: 15 }  // Valore
    ];
    XLSX.utils.book_append_sheet(wb, summaryWs, 'Riepilogo');

    // Prepare detailed data for Excel
    const detailedData = data.map((item, index) => ({
      'Posizione': index + 1,
      'Nome Piatto': item.nome,
      'Quantità Ordinata': item.quantita,
      'Percentuale': `${((item.quantita / data.reduce((sum, d) => sum + d.quantita, 0)) * 100).toFixed(2)}%`,
      'Prezzo Unitario': item.prezzo ? `€${item.prezzo.toFixed(2)}` : 'N/A',
      'Fatturato Piatto': item.prezzo ? `€${(item.prezzo * item.quantita).toFixed(2)}` : 'N/A'
    }));

    // Create detailed worksheet
    const detailedWs = XLSX.utils.json_to_sheet(detailedData);
    
    // Set column widths
    const colWidths = [
      { wch: 12 }, // Posizione
      { wch: 30 }, // Nome Piatto
      { wch: 18 }, // Quantità Ordinata
      { wch: 15 }, // Percentuale
      { wch: 15 }, // Prezzo Unitario
      { wch: 18 }  // Fatturato Piatto
    ];
    detailedWs['!cols'] = colWidths;

    // Add detailed worksheet to workbook
    XLSX.utils.book_append_sheet(wb, detailedWs, 'Dettaglio Piatti');

    // Generate buffer
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Save file
    const data_blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    const timestamp = new Date().toISOString().split('T')[0];
    saveAs(data_blob, `${filename}_${timestamp}.xlsx`);
    
    return true;
  } catch (error) {
    console.error('Errore durante l\'esportazione:', error);
    return false;
  }
};

export const generateOrderCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};